import { PageHeader } from '@organisms';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Divider, Row, Space } from 'antd';
import { FC } from 'react';
import { RouteProps, useNavigate, useParams } from 'react-router-dom';

import { ContentComponent } from 'src/app/components/ContentComponent';
import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import { adminApi } from '../../api/adminApi';
import { FormAdminAccount } from '../../components/FormAdminAccount';
import { TableAdminRoles } from '../../components/TableAdminRoles';
import { AdminDTOType } from '../../types/adminTypes';

export const AdminScreenDetails: FC<RouteProps> = () => {
  useBreadcrumbs([
    {
      label: 'Admin',
      route: '/admin',
    },
    {
      label: 'Dados do Admin',
    },
  ]);

  const { id } = useParams<{ id?: string }>();

  const navigate = useNavigate();

  const fetchAdmin = async () => {
    if (!id) {
      throw new Error('Admin ID is required');
    }
    const response = await adminApi.getAdminById(id);
    return response as AdminDTOType;
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['admin'],
    queryFn: () => fetchAdmin(),
    refetchOnWindowFocus: false,
  });

  const queryClient = useQueryClient();
  const handleReloadAdmin = () =>
    queryClient.invalidateQueries({ queryKey: ['admin'] });
  return (
    <ContentComponent
      isLoading={isLoading}
      isError={isError}
      data-testid='jokeContainer'
    >
      <Row>
        <PageHeader
          backToPath={() => {
            navigate(-1);
          }}
          title={'Admin'}
          subTitle={'Informações do gestor do admin'}
        />
        <Divider />
        <FormAdminAccount admin={data} reloadAdmin={handleReloadAdmin} />
        <Space size={10} direction='vertical' />
        <TableAdminRoles
          data-testid='jokeText'
          roles={data?.roles}
          admin={data}
          reloadAdmin={handleReloadAdmin}
        />
      </Row>
    </ContentComponent>
  );
};
